import { NumberCons, StringConst } from 'src/app/constants/const';

export class PurchaseRequest {
  transactionId: string;
  affiliation: string;
  currency: string;
  total: number;
  totalTax: number;
  shippingCost: number;
  coupon: string;
  items: PurchaseProduct[];
  constructor() {
    this.transactionId = StringConst.empty;
    this.affiliation = StringConst.empty;
    this.currency = StringConst.empty;
    this.total = NumberCons.zero;
    this.totalTax = NumberCons.zero;
    this.shippingCost = NumberCons.zero;
    this.coupon = StringConst.empty;
    this.items = [];
  }
}

export class PurchaseProduct {
  itemCode: string;
  price: number;
  tax: number;
  quantity: number;
  discount: number;
  constructor() {
    this.itemCode = StringConst.empty;
    this.price = NumberCons.zero;
    this.tax = NumberCons.zero;
    this.quantity = NumberCons.zero;
    this.discount = NumberCons.zero;
  }
}

export class PurchaseGoogleProducts {
  transactionId: string;
  affiliation: string;
  currency: string;
  value: number;
  tax: number;
  shipping: number;
  coupon: string;
  items: PurchaseGoogleProduct[];
  constructor() {
    this.transactionId = StringConst.empty;
    this.affiliation = StringConst.empty;
    this.currency = StringConst.empty;
    this.value = NumberCons.zero;
    this.tax = NumberCons.zero;
    this.shipping = NumberCons.zero;
    this.coupon = StringConst.empty;
    this.items = [];
  }
}

export class PurchaseGoogleProduct {
  itemId: string;
  itemName: string;
  discount: number;
  price: number;
  quantity: number;
  constructor() {
    this.itemId = StringConst.empty;
    this.itemName = StringConst.empty;
    this.discount = NumberCons.zero;
    this.price = NumberCons.zero;
    this.quantity = NumberCons.zero;
  }
}
